import Axios from "axios";
import Cookies from 'js-cookie';

const API_URL = process.env.REACT_APP_API_URL;

const AxiosInstance = Axios.create({
    baseURL: API_URL,
    timeout: 30000,
});

var controller = new AbortController();
export const setAuthorizationToken = (token) => {
    token = token || Cookies.get('jwt');
    AxiosInstance.defaults.headers.common.Authorization = token ? `Bearer ${token}` : "";
};


AxiosInstance.interceptors.response.use(function (response) {

    return response;

}, function (error) {
    if (error?.response?.status === 401) {
        controller = new AbortController();
        controller.abort();
        window.location.href = '/login'


    } else if (!error?.response?.status && !Axios.isCancel(error)) {
        controller = new AbortController();
        controller.abort();
    }
    else {
        return Promise.reject(error);
    }
});

export const getMethod = async (url) => {
    const response = await AxiosInstance.get(url);
    return response?.data;
}

export const postMethod = async (url, data) => {
    const response = await AxiosInstance.post(url, data);
    return response?.data;
}

export const putMethod = async (url, data) => {
    const response = await AxiosInstance.put(url, data);
    return response?.data;
}

export const deleteMethod = async (url, data) => {
    const response = await AxiosInstance.delete(url, data);
    return response?.data;
}